import { render, staticRenderFns } from "./wy-va-optimization-response-pie-chart.vue?vue&type=template&id=8442a982&"
import script from "./wy-va-optimization-response-pie-chart.vue?vue&type=script&lang=js&"
export * from "./wy-va-optimization-response-pie-chart.vue?vue&type=script&lang=js&"
import style0 from "./wy-va-optimization-response-pie-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports